module.exports = __webpack_public_path__ + "static/media/mastercard.c4b0ff35.png";